import { render, staticRenderFns } from "./ClassInvite.vue?vue&type=template&id=026189f7&scoped=true&"
import script from "./ClassInvite.vue?vue&type=script&lang=js&"
export * from "./ClassInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026189f7",
  null
  
)

export default component.exports